import React from 'react';
import Navbar from '@/components/salon/Navbar';
import { Card } from '@/components/ui/card';
import { Shield } from 'lucide-react';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <div className="flex items-center space-x-3 mb-4">
            <Shield className="w-8 h-8 text-blue-600" />
            <h1 className="text-4xl font-bold text-slate-900">Datenschutzerklärung</h1>
          </div>
          <p className="text-slate-600">Letzte Aktualisierung: {new Date().toLocaleDateString('de-DE')}</p>
        </div>

        <Card className="p-8">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">1. Datenschutz auf einen Blick</h2>
            <h3 className="text-lg font-semibold text-slate-900 mb-3">Allgemeine Hinweise</h3>
            <p className="text-slate-700 mb-4">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">2. Datenerfassung auf unserer Website</h2>
            <h3 className="text-lg font-semibold text-slate-900 mb-3">Wer ist verantwortlich für die Datenerfassung?</h3>
            <div className="bg-slate-50 p-4 rounded-lg mb-4">
              <p className="text-slate-700"><strong>Verantwortlich:</strong></p>
              <p className="text-slate-700">Herr Galo</p>
              <p className="text-slate-700">Salon Galo</p>
              <p className="text-slate-700">Heilermannstr. 6</p>
              <p className="text-slate-700">45139 Essen</p>
              <p className="text-slate-700">E-Mail: salongalo@gmx.de</p>
            </div>
          </section>

          <section className="mb-8">
            <h3 className="text-lg font-semibold text-slate-900 mb-3">Welche Daten erfassen wir?</h3>
            <ul className="list-disc list-inside text-slate-700 space-y-2 ml-4">
              <li>Kontaktdaten (Name, E-Mail)</li>
              <li>Buchungsinformationen (Datum, Uhrzeit, Service)</li>
              <li>Zahlungsinformationen (über sichere Drittanbieter)</li>
              <li>Technische Daten (IP-Adresse, Browser-Typ, Zugriffszeiten)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">3. Zahlungsabwicklung über Stripe</h2>
            <p className="text-slate-700 mb-3">
              Für Online-Anzahlungen, Mitgliedschaften und Gutscheine nutzen wir den Zahlungsdienstleister Stripe Payments Europe, Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Irland.
            </p>
            <p className="text-slate-700 mb-3">
              Bei einer Zahlung werden die für die Abwicklung erforderlichen Daten direkt an Stripe übermittelt. Dazu können Name, E-Mail-Adresse, Zahlungsdaten, Rechnungsbetrag sowie technische Daten gehören. Wir speichern keine vollständigen Karteninformationen.
            </p>
            <p className="text-slate-700">
              Die Verarbeitung erfolgt zur Vertragserfüllung gemäß Art. 6 Abs. 1 lit. b DSGVO. Weitere Informationen finden Sie in der <a href="https://stripe.com/de/privacy" target="_blank" rel="noreferrer" className="text-blue-600 underline">Datenschutzerklärung von Stripe</a>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">4. Ihre Rechte</h2>
            <p className="text-slate-700 mb-4">
              Sie haben jederzeit das Recht:
            </p>
            <ul className="list-disc list-inside text-slate-700 space-y-2 ml-4">
              <li>Auskunft über Ihre gespeicherten Daten zu erhalten</li>
              <li>Berichtigung unrichtiger Daten zu verlangen</li>
              <li>Löschung Ihrer Daten zu fordern</li>
              <li>Einschränkung der Datenverarbeitung zu verlangen</li>
              <li>Widerspruch gegen die Verarbeitung einzulegen</li>
              <li>Datenübertragbarkeit zu fordern</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">5. Speicherdauer</h2>
            <p className="text-slate-700">
              Wir speichern Ihre Daten nur so lange, wie es für die jeweiligen Zwecke erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen.
            </p>
          </section>

          <section className="bg-blue-50 p-6 rounded-lg">
            <h2 className="text-xl font-semibold text-slate-900 mb-3">Kontakt</h2>
            <p className="text-slate-700 mb-4">
              Bei Fragen zum Datenschutz können Sie uns jederzeit kontaktieren:
            </p>
            <p className="text-slate-700">E-Mail: salongalo@gmx.de</p>
          </section>
        </Card>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
